import VFooter from './VFooter'

export default {
  VFooter
}



// WEBPACK FOOTER //
// ./src/components/footer/index.js